/**
 * Quackback feedback kinds. Board ids come from system_config via feature-flags
 * (`integrations.quackback_board_*`) — slug changes on rename; ids do not.
 *
 * Fallback ids = current staging boards (used only if config is empty).
 */
export const FEEDBACK_KINDS = {
  bug: {
    titlePrefix: 'Bug: ',
    /** Fallback when `integrations.quackback.board_bug` is unset. */
    defaultBoard: 'board_01m5eyf7vjexysvmyj2krj8e5r',
  },
  idea: {
    titlePrefix: 'Idea: ',
    defaultBoard: 'board_01m5eyh707exysvmzyxwhpyjh2',
  },
} as const

export type FeedbackKind = keyof typeof FEEDBACK_KINDS

export type QuackbackBoardIds = {
  bug?: string | null
  idea?: string | null
}

export function resolveFeedbackBoard(
  kind: FeedbackKind,
  boards?: QuackbackBoardIds | null
): string {
  const fromConfig = boards?.[kind]?.trim()
  if (fromConfig) return fromConfig
  return FEEDBACK_KINDS[kind].defaultBoard
}
